import { Spinner } from "../spinner/spinner_await";

export const Forms = (props) => {
  return (
    <>
      <div className="pt-10 sm:pb-16 lg:px-20 sm:mt-0">
        <div className="flex gap-8">
          <div className="hidden 2xl:block w-1/2">
            <div className="px-4 sm:px-0">
              {/* <WhatsappButton /> */}
              <h3 className=" text-3xl font-bold pb-4">{props.title}</h3>
              <p className="mt-1 text-lg">
                {props.description ||
                  "Recuerda ser veraz con la información, de este modo, tienes más posibilidades de que aprobemos tu solicitud."}
              </p>
            </div>
          </div>
          <div className="w-full">
            {props.isSpinner ? (
              <div className="shadow rounded-3xl">
                <div className="px-4 pt-4 py-5 bg-white sm:p-6">
                  <div
                    className="grid grid-cols-12 grid-rows-8 gap-4 pt-4"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignContent: "center",
                      alignItems: "center",
                      padding: "5",
                      height: "32em",
                    }}
                  >
                    <Spinner
                      isSpinner={props.isSpinner}
                      colorSpinner={"rgb(82 0 135)"}
                      textSpinner={props.textSpinner}
                    ></Spinner>
                  </div>
                </div>
              </div>
            ) : (
              props.form
            )}
          </div>
        </div>
      </div>
    </>
  );
};
